module.exports = __webpack_public_path__ + "img/dm.9f471dc6.svg";